import React, { useState, useCallback } from "react";
import Gallery from "react-photo-gallery";

function Lightbox(props) {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = useCallback((event, { photo, index }) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  }, []);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const showPrevious = () => {
    setCurrentImage((index) =>
      index === 0 ? props.picProduct.length - 1 : index - 1,
    );
  };

  const showNext = () => {
    setCurrentImage((index) =>
      index === props.picProduct.length - 1 ? 0 : index + 1,
    );
  };

  return (
    <div className="ProductImages">
      <Gallery
        photos={props.picProduct.map((photo) => ({
          src: photo,
          width: 0.5,
          height: 0.6,
        }))}
        onClick={openLightbox}
      />
      {viewerIsOpen ? (
        <div
          role="dialog"
          aria-modal="true"
          aria-label="نمایش تصویر محصول"
          onClick={closeLightbox}
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1400,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            background: "rgba(0, 0, 0, 0.9)",
          }}
        >
          <div onClick={(event) => event.stopPropagation()}>
            <button type="button" onClick={closeLightbox} aria-label="بستن">
              ×
            </button>
            {props.picProduct.length > 1 && (
              <button
                type="button"
                onClick={showPrevious}
                aria-label="تصویر قبلی"
              >
                ‹
              </button>
            )}
            <img
              src={props.picProduct[currentImage]}
              alt=""
              style={{
                maxWidth: "85vw",
                maxHeight: "85vh",
                objectFit: "contain",
              }}
            />
            {props.picProduct.length > 1 && (
              <button type="button" onClick={showNext} aria-label="تصویر بعدی">
                ›
              </button>
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
}
export default Lightbox;
